import { AlertTriangle, Wrench, Clock } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const kpis = [
  { label: "CA encaissé", value: "142 850 €", note: "+24% ce mois", tone: "text-turquoise" },
  { label: "Réservations", value: "1 480", note: "99,2% confirmées", tone: "text-white/50" },
  { label: "Participants", value: "4 250", note: "Toutes activités", tone: "text-white/50" },
  { label: "Dépenses", value: "53 400 €", note: "Justificatifs suivis", tone: "text-white/50" },
  { label: "Résultat estimé", value: "89 400 €", note: "Marge 62,5%", tone: "text-turquoise" },
  { label: "Alertes opérationnelles", value: "3", note: "À traiter aujourd'hui", tone: "text-amber-400" },
];

const alerts = [
  { icon: Wrench, text: "Quad #12 — révision à planifier", tone: "text-amber-400" },
  { icon: Clock, text: "2 paiements en attente d'encaissement", tone: "text-brand" },
  { icon: AlertTriangle, text: "Jet-ski #4 — incident signalé hier", tone: "text-red-400" },
];

const DashboardKpis = () => (
  <section data-testid="dashboard-kpis-section" className="py-12 sm:py-16">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2rem] bg-navy px-6 py-16 sm:px-12 lg:px-16">
          <div className="pointer-events-none absolute -left-24 top-0 h-72 w-72 rounded-full bg-brand/20 blur-[100px]" aria-hidden="true" />
          <div className="pointer-events-none absolute -bottom-24 right-0 h-72 w-72 rounded-full bg-violet/15 blur-[100px]" aria-hidden="true" />

          <div className="relative max-w-2xl">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-turquoise"><span className="mr-2 font-mono text-white/30">03</span>Tableau de bord</p>
            <h2 className="mt-4 text-balance text-3xl font-bold tracking-tight text-white sm:text-4xl">
              Votre activité en un coup d'œil.
            </h2>
            <p className="mt-4 text-base leading-relaxed text-white/60 sm:text-lg">
              Les indicateurs qui comptent, calculés à partir de votre exploitation réelle — pas d'un tableur à maintenir.
            </p>
          </div>

          <div className="relative mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {kpis.map((k, i) => (
              <Reveal key={k.label} delay={0.06 * i}>
                <div data-testid={`kpi-card-${i}`} className="rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm transition-colors duration-300 hover:border-white/20">
                  <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-white/45">{k.label}</p>
                  <p className="mt-2 font-mono text-3xl font-bold text-white">{k.value}</p>
                  <p className={`mt-1 text-xs font-bold ${k.tone}`}>{k.note}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="relative mt-8 flex flex-wrap gap-3">
            {alerts.map((a) => (
              <span key={a.text} className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs font-semibold text-white/75">
                <a.icon className={`h-3.5 w-3.5 ${a.tone}`} /> {a.text}
              </span>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default DashboardKpis;
